import {IElement, IImageAttributes} from 'routes/private/Editor/types';

export const updateSrcImage = ( element: IElement, value: {srcImage: string, width: number, height: number, brandImage?: string, brandId?: string, brandImageType?: string, brandData?:string[]} ) => {   
    
    (element.attributes as IImageAttributes).srcImage = value.srcImage;    
    (element.attributes as IImageAttributes).brandId = value.brandId!==undefined && value.brandId!==null?value.brandId:undefined;
    (element.attributes as IImageAttributes).brandImageType = value.brandImageType!==undefined && value.brandImageType!==null?value.brandImageType:undefined;
    (element.attributes as IImageAttributes).brandData = value.brandData;
    
  
    const width = element.attributes.image.width, height = element.attributes.image.height, imageWidth = value.width, imageHeight = value.height;
    const ratio = width / height;
    const imageRatio = imageWidth / imageHeight;
    if (ratio !== imageRatio) {
      let x = element.attributes.image.x, y = element.attributes.image.y;
      const modifiedWidth = height * imageRatio;
      const modifiedX = x + (width - modifiedWidth) / 2;
      element.attributes.height = height;
      element.attributes.width = modifiedWidth;
      element.attributes.image.width = modifiedWidth;
      element.attributes.y = y;
      element.attributes.x = modifiedX;
      element.attributes.image.x = modifiedX;
    }
  return element;
}


